import { Swords, Trophy, Trash2 } from "lucide-react";

export function ChallengeCard({ ch, onCrown, onDelete }) {
  const cid = ch.id.slice(0, 8);
  return (
    <div data-testid={`admin-challenge-${cid}`} className="bg-surface rounded-3xl border border-brd shadow-md p-6">
      <div className="flex items-start gap-4">
        <div className={`w-11 h-11 rounded-full flex items-center justify-center shrink-0 ${ch.status === "active" ? "bg-turq-900" : "bg-beige-900 dark:bg-surface2"}`}>
          <Swords className="w-5 h-5 text-white dark:text-turq-300" />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <b className="font-head text-[15px]">{ch.title}</b>
            <span className={`text-[10px] font-bold rounded-full px-2.5 py-0.5 ${ch.status === "active" ? "bg-coral-600 text-white" : "bg-beige-900/40 text-mutext"}`}>
              {ch.status === "active" ? "نشط" : "مكتمل"}
            </span>
          </div>
          <p className="text-xs text-mutext mt-1.5">{ch.description}</p>
          <div className="text-[11px] text-mutext mt-2">{ch.week_start} → {ch.week_end} · {ch.participants_count} مشارك</div>
          {ch.winner_school_name && (
            <div className="mt-2 text-[11.5px] font-bold text-coral-600 flex items-center gap-1">
              <Trophy className="w-3.5 h-3.5" /> الفائز: {ch.winner_school_name}
            </div>
          )}
        </div>
        <button data-testid={`challenge-delete-${cid}`} onClick={() => onDelete(ch.id)}
          className="w-8 h-8 rounded-lg bg-coral-100 dark:bg-surface2 flex items-center justify-center shrink-0">
          <Trash2 className="w-3.5 h-3.5 text-coral-900 dark:text-coral-300" />
        </button>
      </div>
      {ch.status === "active" && (
        <div className="mt-4 text-left">
          <button data-testid={`challenge-close-${cid}`} onClick={() => onCrown(ch)}
            className="text-[11.5px] font-bold text-white bg-turq-600 hover:bg-turq-900 rounded-full px-5 py-2 transition-colors">
            إغلاق وتتويج الفائز
          </button>
        </div>
      )}
    </div>
  );
}
